// src/services/emailService.ts
import emailjs from '@emailjs/browser';

const SERVICE_ID  = 'service_pnamedh';
const TEMPLATE_ID = 'template_8s4g9do';
const PUBLIC_KEY  = 'c8USHKKGOfgosadCv';

export interface ContactPayload {
  from_name:  string;
  from_email: string;
  service:    string;
  message:    string;
}

export async function sendContactEmail(payload: ContactPayload): Promise<void> {
  const result = await emailjs.send(SERVICE_ID, TEMPLATE_ID, payload, PUBLIC_KEY);
  if (result.status !== 200) {
    throw new Error(`EmailJS error: ${result.text}`);
  }
}